import useDebounce from 'src/hooks/useDebounce'

import { Form as AntForm, FormProps } from 'antd'

const Form = (props: FormProps) => {
    const { initialValues, form, children, onValuesChange, onFinish, ...rest } = props

    const { debounce } = useDebounce({ onChange: onValuesChange })

    return (
        <AntForm
            {...rest}
            form={form}
            initialValues={initialValues}
            onValuesChange={(changedValues, values) => debounce(changedValues, values)}
            onFinish={(values) => {
                const changedValues = initialValues
                    ? Object.keys(values).reduce(
                          (acc, key) => {
                              if (values[key] !== initialValues[key]) {
                                  acc[key] = values[key]
                              }
                              return acc
                          },
                          {} as Record<string, unknown>,
                      )
                    : values

                onFinish?.(changedValues)
            }}
        >
            {isNodeChildren(children) ? children : children(form.getFieldsValue(), form)}
        </AntForm>
    )
}

const isNodeChildren = (children: FormProps['children']): children is React.ReactNode => typeof children !== 'function'

export default Form
